module.exports = __webpack_public_path__ + "static/media/ic-close-small.faded.0f3c899a.svg";